import { S, queue } from "./store.ts";

/**
 * Counts the seconds a child is really using Numi: the page is visible AND there was a tap, key or scroll in the last 30 s.
 * Sent as small "time" events through the same offline-safe queue as everything else.
 */
const TICK = 5, IDLE_MS = 30e3, SEND_AT = 30;
let lastTouch = 0, acc = 0;

function emit() { const secs = Math.round(acc); acc = 0; if (secs > 0 && S.child) queue({ type: "time", secs }); }

export function startActivity() {
  const bump = () => { lastTouch = Date.now(); };
  for (const ev of ["pointerdown", "keydown", "touchstart", "scroll", "input"]) window.addEventListener(ev, bump, { passive: true, capture: true });
  setInterval(() => {
    if (document.visibilityState !== "visible" || !S.child || Date.now() - lastTouch > IDLE_MS) return;
    acc += TICK; S.sinceBreak += TICK; if (acc >= SEND_AT) emit();
  }, TICK * 1000);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") emit(); });
}
